import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { IntermarketingDetailsPage } from './intermarketing-details';
import { RoundProgressModule } from 'angular-svg-round-progressbar';

@NgModule({
  declarations: [
    IntermarketingDetailsPage,
  ],
  imports: [
    IonicPageModule.forChild(IntermarketingDetailsPage),
    RoundProgressModule
  ],
})
export class IntermarketingDetailsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/intermarketing-details/intermarketing-details.module.ts